import React from "react";
import HotelBooking from "./bookings/HotelBooking";

const Dashboard = () => {
  return (
    <div>
      <HotelBooking />
    </div>
  );
};

export default Dashboard;
